// Vehicle Acceptance Form (VAF) status codes.
// Previously this enum was copy-pasted in three places: index.jsx,
// components/VehicleAcceptanceFormDialog.jsx and hooks/useUpdateVehicleAcceptanceForm.js.
// Kept in one place so the three copies can't drift out of sync.
export const VAFStatus = {
    DRAFT: 5,
    SENT_FOR_APPROVAL: 20,
    RETURNED: 25,
    APPROVED: 30
};
